<template>

    <div class="mx-sm-1 mt-9">
        <div class="page-header">
            <h1 class="page-title fw-bold">Vérification de cadrage</h1>
            <div>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de
                                bord</a></router-link></li>
                    <li class="breadcrumb-item active" aria-current="page"><router-link
                            :to="{ name: 'verificationCadrage' }"><a>Vérification</a></router-link></li>
                </ol>
            </div>
        </div>

        <div class="my-2">
            <router-link :to="{ name: 'pta', params: {  annee:anneeRoute }}"><a><i class="fe fe-arrow-left"></i>
                    Retour</a></router-link>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12">


                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="form-label">Année <span class="text-danger">*</span></label>
                                    <multi-select deselect-label="Sélectionné" select-label="" :options="exercices"
                                        @select="selectAnnee" placeholder="Sélectionné " label="annee" track-by="annee"
                                        :searchable="true" :custom-label="o => o.annee" v-model="payload.exercice">
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong> {{ option.annee }}</strong>
                                        </template>
                                        <span slot="noOptions">
                                            <strong>Liste Vide</strong>
                                        </span>
                                        <span slot="noResult">
                                            <strong>Aucun Résultat</strong>
                                        </span>
                                    </multi-select>


                                </div>
                            </div>

                        </div>

                        <hr>
                        <div class="table-responsive">
                            <table class="table table-hover table-bordered text-wrap border-bottom mb-0" id="my">
                                <thead class="border-top text-white" style="background-color: #457e9e!important;">
                                    <tr class="fw-bold">
                                        <th class="bg-transparent border-bottom-0 fw-bold" style=""
                                            @click="sortBy('action')">Action
                                            et projet</th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">Montant cadrage
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">Montant saisie
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">Ecart
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold"
                                            @click="sortBy('montantCpBn')">Statut
                                        </th>
                                        <th class="bg-transparent border-bottom-0 fw-bold" style="width: 5%;">Actions
                                        </th>
                                    </tr>
                                </thead>

                                <tfoot>
                                    <tr class="fw-bold bg-light">
                                        <td colspan="6"></td>
                                    </tr>

                                </tfoot>

                                <tbody v-if="sortedItems.length > 0" id="myTable1">
                                    <template v-for="(item, index) in sortedItems">
                                        <!-- Ligne principale -->
                                        <tr class="border-bottom" style="background-color: #d0e6e9;">
                                            <td colspan="5">
                                                <p class="fw-bold mb-0 text-break"
                                                    style="white-space: normal; word-break: break-word;">
                                                    {{ item.action }}
                                                </p>
                                            </td>
                                            <td>
                                                <button class="btn btn-warning btn-sm text-white"
                                                    @click.prevent="toggleDetail(item)">
                                                    <span class="fe fe-eye fs-18"></span>
                                                </button>
                                            </td>
                                        </tr>

                                        <!-- Composantes, affichées uniquement si item sélectionné -->
                                        <tr v-for="(projet, idx) in item.items" :key="`compo-${index}-${idx}`"
                                            v-if="selectedItem === item || selectedItem === 'ALL'">
                                            <td colspan="1">{{ projet.nomProjetPag }}</td>

                                            <td class="text-end">
                                                {{ projet?.montantCadrage }}
                                            </td>
                                            <td class="text-end">
                                                {{ projet?.cumulBesoin }}
                                            </td>
                                            <td class="text-end">
                                                {{ projet?.ecart }}
                                            </td>
                                            <td class="text-end">
                                                {{ projet?.statutVerification }}
                                            </td>
                                            <td>
                                                <button class="btn btn-primary btn-sm text-white"
                                                    @click.prevent="edit(projet)">
                                                    Confirmer cadrage
                                                    <span class="fe fe-cheked fs-18"></span>
                                                </button>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>

                                <tbody v-else>
                                    <tr class="primary02">
                                        <td colspan="6" class="text-center">Aucun Cadrages trouvé</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <nav v-if="pageCount > 1" class="mt-2">
                            <ul class="pagination justify-content-end">
                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                    <a class="page-link" href="#"
                                        @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                                </li>
                                <li v-for="page in pageCount" :key="page" class="page-item"
                                    :class="{ active: currentPage === page }">
                                    <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                                    <a class="page-link" href="#"
                                        @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                                </li>
                            </ul>
                        </nav>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import $ from 'jquery';
import { mapGetters, mapActions } from 'vuex';
import * as lang from "vuejs-datepicker/src/locale";
export default {
    name: "GenerationPta",
    data() {
        return {
            localItems: [], selectedItem: null,anneeRoute:'',
            lang: lang, payload: { currentStep: 1, classeur: null, composante: "" }, pta: { annee: "", dateDebut: "", dateFin: "", description: "", besoinAeBnTtc: 0, besoinAePretTtc: 0, besoinAeDonTtc: 0, besoinAeAntTtc: 0, besoinAeBaTtc: 0, besoinAeTotTtc: 0, besoin_cp_bn_ttc: 0, besoinCpPretTtc: 0, besoinCpDonTtc: 0, besoinCpAntTtc: 0, besoinCpBaTtc: 0, besoinCpTotTtc: 0 },
            save: true, showList: true, notModified: false, choixCompo: false, choixAnnee: false,
            classeurs: [], composantes: [], exercices: [], typologies: [], lesactivites: [], lestaches: [], ptas: [], activite: null
        }
    },
    computed: {
        ...mapGetters({ items: 'projetPag/list' }),
        fr() {
            return this.lang.fr;
        },
        activeStep() {
            return this.steps[this.payload.currentStep - 1];
        },
        isLastStep() {
            return this.payload.currentStep === this.steps.length;
        },
        filtersItems() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.sortedItems.slice(start, start + this.perPage);
        },
        groupedItems() {
            return this.localItems.reduce((groups, item) => {
                const actionKey = item.idAction?.idAction || 'Autre';
                if (!groups[actionKey]) {
                    groups[actionKey] = {
                        action: item.idAction?.libelleAction || 'Autre',
                        items: []
                    };
                }
                groups[actionKey].items.push(item);
                return groups;
            }, {});
        },
        sortedItems() {
            console.log(this.groupedItems);
            return Object.values(this.groupedItems).sort((a, b) => {
                const aVal = this.resolveSortValue(a);
                const bVal = this.resolveSortValue(b);
                return this.currentSortDir === 'asc'
                    ? (aVal > bVal ? 1 : -1)
                    : (aVal < bVal ? 1 : -1);
            });
        },

        pageCount() {

            return Math.ceil(this.sortedItems.length / this.perPage);
        },


    },
    watch: {
        imported: {
            immediate: true,
            handler(val) {
                if (val) this.payload.currentStep++;
            },
        },
    },
    mounted() {
    },
    methods: {
        ...mapActions('generationPta', ['all', 'add']),
        isEmpty(value) {
            return value === null || value === '' || (typeof value === 'object' && Object.keys(value).length === 0);
        },
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            this.$router.push({ query: this.option }).catch(() => { });


        },
        getExercices() {
            this.$http.get('/exercice')
                .then(({ data }) => {
                    console.log(data);
                    console.log(1);
                    this.exercices = data;

                });
        },
        selectAnnee() {
            this.$loading(true);
            this.$http.get(`/cadrage/verificationCadrage/${this.payload.exercice.annee}`)
                .then(({ data }) => {
                    this.localItems = data;
                    this.$loading(false);
                });
        },
        formatDate(dateStr) {
            const date = new Date(dateStr);
            return date.toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },
        sortBy(column) {
            if (this.currentSort === column) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort = column;
                this.currentSortDir = 'asc';
            }
        }, toggleAll() {
            this.allExpanded = !this.allExpanded;
            this.selectedItem = this.allExpanded ? 'ALL' : null;
        }, toggleDetail(item) {
            // Si déjà ouvert, fermer ; sinon, ouvrir
            if (this.selectedItem === item) {
                this.selectedItem = null;
            } else {
                this.selectedItem = item;
            }
        }, changePage(page) {
            if (page >= 1 && page <= this.pageCount) {
                this.currentPage = page;
            }
        },
        resolveSortValue(item) {
            const val = item[this.currentSort];
            if (this.currentSort === 'auteur') {
                return item.user?.firstname + ' ' + item.user?.lastname;
            }
            return typeof val === 'string' ? val.toLowerCase() : val;
        },

    },
    created() {
        this.anneeRoute = this.$route.params.annee;
        this.onSearch()
        this.getExercices()
        this.$http.get('/typologiePta')
            .then(({ data }) => {
                console.log(data);
                console.log(1);
                this.typologies = data;
            });
        this.$loading(false);


    },
}
</script>

<style></style>